const REDUX_SLICE_NAMES = {
  LOADING_FULL_SCREEN: 'loadingFullScreen',
  CONFIRM_MODAL: 'confirmModal',
  TOAST_NOTIFICATION: 'toastNotification',
  CUSTOM_TABLE: 'customTable',
  USER: 'user',
  ROLE: 'role',
  SEARCH_TEXT: 'searchText',
  ACCORDION: 'accordionTree',
  URL_ID: 'urlId',
  DETAIL_TOPIC: 'detailTopic',
};

export default REDUX_SLICE_NAMES;
